export class ForecastParksWinglogProvider {

    public _id: string;
    public name: string;
    public displayName: string;
    public country: string;
    public countryCode: string;
    public isWindlogForecastAvailable: boolean;
    public isMeteologicaForecastAvailable: boolean;
    public isDNVForecastAvailable: boolean;

    static mapData(data: any) {
        return data.map(p => {
          return new ForecastParksWinglogProvider({
            _id: p._id,
            name: p.name,
            displayName: p.fe_name,
            country: p.country?.name,
            countryCode: p.country?.code,
            isWindlogForecastAvailable: p.isWindlogForecastAvailable,
            isMeteologicaForecastAvailable: p.isMeteologicaForecastAvailable,
            isDNVForecastAvailable: p.isDNVForecastAvailable
          });
        })
      }

  constructor(init: Partial<ForecastParksWinglogProvider>) {
    Object.assign(this, init);
  }
}
